<template>
   <ul :class="['fleet-list']"  ref="fleest">
     <li v-for="(fleet, index) in fleets">
        <a :class="{'selectedFleet': index == selected.fleetIndex}" href="#" @click.prevent="selectFleet(index);scrollList();">{{ fleet.name }}</a>
     </li>
    </ul>
</template>

<style>

    ul.fleet-list {
        display: flex;
        flex-flow: row;
        justify-content: center;
    }

    .fleet-list li{
        padding: 10pt;
        font-size: 24px;
    }

    @media and (max-width:768px){
        ul.fleet-list li {flex-basis: 50%;}
    }

</style>
<script>
import {mapGetters, mapActions} from 'vuex'

export default{
    data(){
        return {
            newFleet: ""

        }
    },
    computed: {
      ...mapGetters(['lng', 'isLoaded', 'isBlocked', 'fleets', 'selected', 'show'
      ])
    },
    methods: {
      ...mapActions(['selectFleet']),
        scrollList(){
            document.getElementById('vsl-list').scrollTo({
                top:0,
                behavior: "smooth"
            });
        }
    }
}
</script>




// WEBPACK FOOTER //
// Fleets.vue?67ed383f